import { DIALOG_TYPE, LAUNCH_CALLER, LayoutConfig } from '@spartacus/storefront';
import { CuttingWrapperComponent } from '../cutting-wrapper/cutting-wrapper.component';

export const cuttingModalLayoutConfig: LayoutConfig = {
  launch: {
    [LAUNCH_CALLER.CUTTING]: {
      inlineRoot: true,
      component: CuttingWrapperComponent,
      dialogType: DIALOG_TYPE.DIALOG,
      dialogOptions: {
        onTop: true,
      },
    },
  },
};
